import { type QuestionStatus } from '@exam-management/graphql';
import { FormSelection, EllipsisText, Text, Chip, type GridColDef } from '@shared/components';

import type { QuestionReviewUpdateQuestionStatusRow } from '../../types';

import { StatusItem, statusOptions } from './columns';

const itemSetColumns: GridColDef<QuestionReviewUpdateQuestionStatusRow>[] = [
  {
    field: 'order',
    headerName: 'No',
    width: 36,
    sortable: false,
    renderCell: (params) => <Text>{params.row.order}</Text>,
  },
  {
    field: 'QID',
    headerName: 'QID',
    width: 210,
    sortable: false,
    renderCell: (params) => <EllipsisText>{params.row.qid}</EllipsisText>,
  },
  {
    field: 'itemSetType',
    headerName: 'Item Set Type',
    width: 128,
    sortable: false,
    renderCell: (params) => (
      <Chip
        label={<Text variant='captionSemibold'>{params.row.itemSetType}</Text>}
        size='small'
        sx={(theme) => ({
          backgroundColor: theme.palette.info.light,
          minWidth: '62px',
        })}
      />
    ),
  },
  {
    field: 'itemSetName',
    headerName: 'Item Set Name',
    flex: 1,
    sortable: false,
    renderCell: (params) => <EllipsisText>{params.row.itemSetName}</EllipsisText>,
  },
  {
    field: 'toStatus',
    headerName: 'Question Status',
    width: 160,
    sortable: false,
    align: 'center',
    headerAlign: 'center',
    renderCell: (params) => {
      return (
        <FormSelection
          name={`questions.${params.id}`}
          placeholder='Select Status'
          options={statusOptions}
          sx={{ maxWidth: 160, width: '100%', '& .MuiInputBase-root': { height: 32 } }}
          size='small'
          itemComponent={({ option }) => {
            const status = option.value as QuestionStatus;

            return <StatusItem status={status} />;
          }}
          slotProps={{
            select: {
              renderValue: (value) => {
                const status = value as QuestionStatus;
                return <StatusItem status={status} />;
              },
            },
          }}
        />
      );
    },
  },
];

export default itemSetColumns;
